import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import "react-table-6/react-table.css";
import $ from 'jquery';
import 'react-widgets/dist/css/react-widgets.css';
import WhatsappConfiguration from './WhatsappConfiguration';
import GoogleRcsConfiguration from './GoogleRcsConfiguration';

class Configuration extends Component {
  constructor() {
    super();
   
  }

  componentDidMount() {
     
    (function () {
      var currentPath = window.location.href;
      var currentPath = window.location.href;
      var path = window.origin + "/sales-desk/projectmgmt/settings/configuration";
      var path1 = window.origin + "/sales-desk/projectmgmt/settings/configuration/";
      if (currentPath === path || currentPath === path1) {
          $("#whatsapp-conf").addClass('active');
      } else if (currentPath.includes("/projectmgmt/settings/whatsapp")) {
          $("#whatsapp").addClass('active');
      }else {
          $("#" + localStorage.getItem("last-conf-data-tab")).addClass('active')
      }
      $("#whatsapp-conf,#googlercs-conf")
          .on("click", function () {
              $("#whatsapp-conf,#googlercs-conf")
                  .removeClass('active');
              localStorage.setItem("last-conf-data-tab", $(this)[0].id);
              $(this).addClass('active')
          })
  })();
  }

  
  render() {
    
    return (

      <div id="tabPage">
          <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

              <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
              <title> Dheeyantra | Clusters Details</title>
              {/* Font Awesome Icons */}
              <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
              {/* IonIcons */}
              <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
              <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
              {/* Theme style */}
              <link rel="stylesheet" href="assets/css/adminlte.css" />
              <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
              <link rel="stylesheet" href="assets/css/custom-style.css" />
              <link rel="stylesheet" href="assets/css/styles.css" />
              <link rel="stylesheet" href="assets/css/custom-style.css" />
             

              <div className="container-fluid" >
                  {/* Nav tabs */}
                  <div className="border-botto"></div>
                  <div className="tab-class">
                      <ul className="nav nav-tabs border-botto navCluster">
                          <Link className="nav-item" data-toggle="tab"
                              to="/projectmgmt/settings/configuration" style={{ textDecoration: 'none' }}>
                              <li className="nav-link" id="whatsapp-conf" style={{ marginRight: '15px' }}>
                              Whatsapp
                              </li></Link>
                          <Link className="nav-item" data-toggle="tab"
                              to="/projectmgmt/settings/configuration/googlercs" style={{ textDecoration: 'none' }}>
                              <li className="nav-link" id="googlercs-conf" style={{ marginRight: '15px' }}>
                                  GoogleRcs
                              </li></Link>
                         
                         
                      </ul>
                  </div>
              </div>
          </div>
          <Switch>
              <Route exact path="/projectmgmt/settings/configuration" component={WhatsappConfiguration}></Route>
              <Route path="/projectmgmt/settings/configuration/googlercs" component={GoogleRcsConfiguration}></Route>
              
          </Switch>
      </div>

  );

  }
}

export default Configuration;


// WEBPACK FOOTER //
// ./src/sales-desk/projectmgmt/Configuration.js